import type { MouseEvent, ReactNode } from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import { Breadcrumbs } from '@repo/ui';

interface StageHeaderProps {
  title: ReactNode;
  titleWrapperSx?: BoxProps['sx'];
  isVerticalHeader?: boolean;
  onBackButtonClick?: () => void;
}

export const StageHeader = ({
  title,
  titleWrapperSx,
  isVerticalHeader,
  onBackButtonClick,
}: StageHeaderProps) => {
  const handleBackButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    onBackButtonClick?.();
  };

  return (
    <>
      {onBackButtonClick ? <Breadcrumbs onClick={handleBackButtonClick} /> : null}
      <Box
        sx={{
          marginBottom: isVerticalHeader ? { xs: '14px', sm: '6px', md: '30px' } : '20px',
          ...titleWrapperSx,
        }}
      >
        {title}
      </Box>
    </>
  );
};
